import { useQuery } from '@tanstack/react-query';
import { apiClinicList } from 'lib/api/firebase/apis/apis';

export function useGetOrganizations() {
  return useQuery({
    queryKey: ['organizations'],
    queryFn: () => apiClinicList().then(_ => _.data.organisations)
  });
}
